import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteSMInvoiceRequest {
  attachIds: number[];
  invoiceId?: number;
}

const useDeleteScanManagerInvoicesApi = () => {
  const call = useCallback(async (params?: DeleteSMInvoiceRequest) => {
    try {
      const res = await axiosInstance.post(api.deleteScanManagerInvoiceRecord, params?.attachIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { execute, isLoading } = useAsync(call, false);
  return { deletePendingInvoiceAttachments: execute, isDeleteInvoiceAttachmentsLoading: isLoading };
};

export default useDeleteScanManagerInvoicesApi;
